import { window } from '@mtsbank/ui-kit'
import environment, { Environment } from './base'

export const baseApi: string = window.location.origin
const additionalProps = {
  isProduction: true,
}
const env = environment(baseApi, additionalProps)

const productionEnv: Environment = {
  ...env,
}

export default productionEnv
